/**
 * Extract first phone number from potentially comma-separated list
 */
export const getFirstPhone = (phone: string): string => {
  return phone.split(",")[0].trim();
};

/**
 * Normalize phone number by removing +, spaces, parentheses, and hyphens
 */
export const normalizePhone = (phone: string): string => {
  return phone.replace(/[\s+\-()]/g, "");
};

/**
 * Check if the user phone contains the target phone (handles multiple phones separated by commas)
 */
export const hasPhoneMatch = (targetPhone: string, userPhoneString: string): boolean => {
  const normalizedTarget = normalizePhone(targetPhone);
  const userPhones = userPhoneString.split(",").map((p) => normalizePhone(p.trim()));
  return userPhones.some((phone) => phone === normalizedTarget);
};
